class ProfileLeadPanelPrices {
	estimated_price;
	unitTypes = {
		contactForPrice: "Contact for price",
		hourly: "/ hour",
		consultation: "/ consultation",
		fixed: "",
	};

	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this.estimated_price = staticContext.estimated_price;
	}

	get profileActionsPanelStore() {
		return this.rootStore.stores.profileActionsPanelStore;
	}

	get quote() {
		return this.profileActionsPanelStore.quote;
	}

	get leadKey() {
		return this.profileActionsPanelStore.leadKey;
	}

	get total() {
		return this.quote?.final_price.total || this.estimated_price?.total;
	}

	get unit() {
		return this.quote?.final_price.unit || this.estimated_price?.unit;
	}

	get description() {
		return (
			this.quote?.final_price.description || this.estimated_price?.description
		);
	}

	get displayChatBubble() {
		if (!this.total) return true;
		return false;
		//return this.unit === this.unitTypes.contactForPrice;
	}

	get displayUnitSpan() {
		if (!this.unit) return false;
		return true;
	}

	get subHeader() {
		return this.description;
	}
}

export default ProfileLeadPanelPrices;
